module.exports = __webpack_public_path__ + "staticmedia/media/Roboto-Bold.7cb27a07.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fonts/Roboto-Bold.ttf
// module id = 110
// module chunks = 0